import {
  PAYMENT_SCHEDULE_AMOUNT_OPTIONS,
  PAYMENT_SCHEDULE_PERIOD_OPTIONS,
  PAYMENT_SCHEDULE_STANDARD_PERIOD_OPTIONS,
  PAYMENT_SCHEDULE_SILVER_PERIOD_OPTIONS,
  PAYMENT_SCHEDULE_GOLD_PERIOD_OPTIONS,
} from "config"
import { PlanNameType } from "types"

interface PaymentSchedulePlan {
  min: number
  max: number
  middle: number
  step: number
}

const PAYMENT_SCHEDULE_PLAN_OPTIONS: Record<PlanNameType, PaymentSchedulePlan> =
  {
    standard: PAYMENT_SCHEDULE_STANDARD_PERIOD_OPTIONS,
    silver: PAYMENT_SCHEDULE_SILVER_PERIOD_OPTIONS,
    gold: PAYMENT_SCHEDULE_GOLD_PERIOD_OPTIONS,
  }

export const calculateAmount = (balance: number, period: number): number => {
  const { min: amountMin } = PAYMENT_SCHEDULE_AMOUNT_OPTIONS

  const initialAmount = Math.ceil(balance / period)

  return Math.min(balance, Math.max(amountMin, initialAmount))
}

export const calculatePeriod = (balance: number, amount: number): number => {
  const { min: periodMin, max: periodMax } = PAYMENT_SCHEDULE_PERIOD_OPTIONS

  const initialPeriod = Math.ceil(balance / amount)

  return Math.min(periodMax, Math.max(periodMin, initialPeriod))
}

export const calculateSliderValues = (balance: number) => {
  const { min: amountMin, step: amountStep } = PAYMENT_SCHEDULE_AMOUNT_OPTIONS
  const {
    min: periodMin,
    max: periodMax,
    step: periodStep,
  } = PAYMENT_SCHEDULE_PERIOD_OPTIONS

  const amount = calculateAmount(balance, periodMax)
  const period = calculatePeriod(balance, amount)

  const min = Math.max(amountMin, amount)
  const max = Math.min(balance, amount * period)

  const middlePeriod = Math.min(Math.ceil(period / 2), period)
  const middleAmount = Math.ceil(balance / middlePeriod)

  const amountOptions = {
    min: min,
    middle: middleAmount,
    max: max,
    step: amountStep,
  }

  const periodOptions = {
    min: periodMin,
    middle: middlePeriod,
    max: period,
    step: periodStep,
  }

  return {
    amountOptions,
    periodOptions,
  }
}

export const calculatePlan = (value: number): PlanNameType => {
  for (const plan in PAYMENT_SCHEDULE_PLAN_OPTIONS) {
    if (
      value >= PAYMENT_SCHEDULE_PLAN_OPTIONS[plan as PlanNameType].min &&
      value <= PAYMENT_SCHEDULE_PLAN_OPTIONS[plan as PlanNameType].max
    ) {
      return plan as PlanNameType
    }
  }
  return "Unknown" as PlanNameType
}
